// T-17 (T17-D12) — the Submission Details tab lives in the URL (`?tab=`) so a
// deep link, reload and Back/Forward keep it. This is the one parser.

export const SUBMISSION_TAB_KEYS = ['documents', 'forms', 'lifecycle', 'node-extensions'] as const;

export type SubmissionTabKey = (typeof SUBMISSION_TAB_KEYS)[number];

/** Parse a raw `?tab=` value; anything not an exact tab key is null. */
export function parseSubmissionTab(raw: string | null | undefined): SubmissionTabKey | null {
  if (typeof raw !== 'string') return null;
  return (SUBMISSION_TAB_KEYS as readonly string[]).includes(raw) ? (raw as SubmissionTabKey) : null;
}
